<template lang="pug">
  multiselect(
    class="mx-auto"
    :value="selectedBuilding"
    @input="redirect"
    open-direction="bottom"
    label="label"
    :options="buildings"
    :show-labels="false"
    :searchable="false"
  )
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  props: {
    buildings: {
      type: Array,
      required: true
    },
    selectedBuilding: {
      type: Object,
      default: () => null
    }
  },

  methods: {
    redirect (building) {
      window.location.href = building.value
    }
  }
}
</script>
